import Vue from 'vue';
import Vuex from 'vuex';
import style from './modules/style';
import user from './modules/user';
import school from './modules/school';
import message from './modules/message';
import types from './modules/types';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    style,
    user,
    school,
    message,
    types,
  },
});



// WEBPACK FOOTER //
// ./src/vuex/store.js